import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { useSidebarProjectInteractionsFactory } from '#pplx/frontend/apps/ask/hooks/sidebar-project-actions/useSidebarProjectInteractions.js';
import { renderProjectMenuItems } from '#pplx/frontend/apps/ask/spaces-redesign/ProjectMenuItems.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React, { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
function noop() { }
function selectHandler(action) {
    switch (action.kind) {
        case 'available':
            return action.onSelect;
        case 'unavailable':
            return noop;
        default:
            return assertUnreachableValue(action);
    }
}
export const SidebarProjectActionsMenu = ({ space, isPinned }) => {
    const { $t } = useIntl();
    const createInteractions = useSidebarProjectInteractionsFactory();
    const interactions = useMemo(() => createInteractions({ project: space, pinned: isPinned }), [createInteractions, isPinned, space]);
    const [isOpen, setIsOpen] = useState(false);
    const projectActionsLabel = $t({
        defaultMessage: 'Project actions',
        description: 'Accessible label for the project overflow menu button in the sidebar',
        id: '80266fdfe8',
    });
    const triggerElement = (_jsx(Tooltip, { content: projectActionsLabel, children: _jsx(ButtonPrimitive, { "aria-label": projectActionsLabel, className: "size-6 grid place-items-center rounded-md shrink-0 text-tertiary md:hover:bg-soft md:hover:text-primary group-hover/sidebar-sub-menu:text-primary keyboard:focus-visible:bg-soft keyboard:focus-visible:text-primary", interactableVariant: "alt", children: _jsx(Icon, { icon: $icon('dots'), size: "medium" }) }) }));
    const handleToggle = useCallback((nextIsOpen) => {
        if (nextIsOpen && !isOpen)
            interactions.trackMenuOpened();
        setIsOpen(nextIsOpen);
    }, [interactions, isOpen]);
    return (_jsx(DropdownMenu, { isOpen: isOpen, onToggle: handleToggle, triggerElement: triggerElement, align: "end", children: renderProjectMenuItems({
            canLeave: interactions.leave.kind === 'available',
            handleDeleteSpace: selectHandler(interactions.delete),
            handleLeaveSpace: selectHandler(interactions.leave),
            handlePinToggle: interactions.pinToggle.onSelect,
            isOwner: interactions.delete.kind === 'available',
            isPinned,
            isUserLoggedIn: true,
        }, { Item: DropdownMenu.Item, Separator: DropdownMenu.Separator }, $t) }));
};
//# sourceMappingURL=SidebarProjectActionsMenu.js.map